export enum ProviderVerificationStatus {
    Unknown,
    Verified,
    DoesNotExist,
    Private,
    VerificationFailed,
    Blocked,
}